import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SeatBookingData } from '../../Redux/action/seatBookingAction';

import { toast } from 'react-toastify';

import dayjs from 'dayjs';
import axios from 'axios';
import { LocationFilterAction } from '../../Redux/action/seatAction';
import { dataUser, logoutHandler, dataLocation } from '../Helpers/util';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwIconButton from '../Common/SwIconButton/SwIconButton';
import SwButton from '../Common/SwButtons/SwButtons';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
var options = [];
var options1 = [];
var options2 = [];
class SeatBookingFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshSeat: null,
      showFilterOffCanvas: false,
      refreshUser: null,
      refreshphone: null,
      locationData: [],
      locationData1: [],
      company_id: UserObj.company_id,
      pgno: this.props.filterPage,
      row: this.props.filterRow,
      type: null,
      seatno: '',
      name: '',
      phone: '',
      location: JSON.stringify(LocationObj),
      locationSpoc: [],
      locationFilter: [],
      startDate: '',
      endDate: '',
      status: '',
      category: '',
    };
  }
  reload = e => {
    const params = {
      company_id: UserObj.company_id,
      pgno: this.props.filterPage,
      row: this.props.filterRow,
    };
    if (!UserObj?.company_id) {
      logoutHandler();
    }
    this.props.onSelectLanguage(params);
    this.props.SeatBookingData(params);
    window.location.reload();

    this.setState({
      type: '',
      seatno: '',
      name: '',
      phone: '',
      location: '',
      startDate: '',
      endDate: '',
      status: '',
      type: '',
      refreshSeat: null,
      refreshUser: null,
      refreshphone: null,
      category: '',
    });
  };

  changeSelect = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleOpenFilter = () => {
    this.setState({ showFilterOffCanvas: true });
  };

  handleCloseFilter = () => {
    this.setState({ showFilterOffCanvas: false });
  };

  componentDidMount() {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    const params = {
      params: { spoc: UserObj.rec_id, client: UserObj.company_id },
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    };
    axios
      .get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        params,
      )
      .then(res => {
        if (res.data.status == 'success') {
          this.setState({
            locationSpoc: res.data.data,
          });
        }
      });

    this.locationValue();
  }

  handelChangeValLang = e => {
    if (e.target.value == 'all') {
      this.setState({
        locationFilter: JSON.stringify(LocationObj),
        location: JSON.stringify(LocationObj),
      });
    } else {
      this.setState({
        locationFilter: `[${e.target.value}]`,
        location: e.target.value,
      });
    }
  };

  submitFilter = async () => {
    options = [];
    options1 = [];
    options2 = [];

    const params = {
      company_id: UserObj.company_id,
      pgno: this.props.filterPage,
      row: this.props.filterRow,
      type: this.state.type,
      seatno: this.state.seatno,
      name: this.state.name,
      phone: this.state.phone,
      location:
        this.state.locationFilter?.length > 0
          ? this.state.locationFilter
          : this.state.location,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      status: this.state.status,
      cat: this.state.category,
    };

    if (!UserObj?.company_id) {
      logoutHandler();
      return;
    }

    try {
      await this.props.SeatBookingData(params);
      this.props.onSelectLanguage(params);

      // ✅ Show success toast AFTER API success
      toast.success('Filter applied successfully');

      this.handleCloseFilter();
    } catch (error) {
      toast.error('Something went wrong');
    }
  };

  handleChange = seatno => {
    this.setState({
      seatno: seatno.value,
      refreshSeat: seatno,
    });
  };

  handleChange1 = name => {
    this.setState({
      name: name.value,
      refreshUser: name,
    });
  };

  handleChange2 = phone => {
    this.setState({ phone: phone.value, refreshphone: phone });
  };

  handleChange3 = location => {
    this.setState({ location: location.value, location: location });
  };

  setuserlist = () => {
    const params = {
      pgno: 1,
    };
    this.props.SeatBookingData(params);
  };

  componentWillReceiveProps(props) {
    if (props.LocationList && props.LocationList.status == 200) {
      this.setState({
        locationData:
          props.LocationList &&
          props.LocationList?.data &&
          props.LocationList?.data?.data,
      });
    }
  }

  /*1---setCity---*/
  locationValue = () => {
    const formData = {
      company_id: this.state.company_id,
      // token: 'U21hcnR3b3Jrcy1GZWVkYmFjay1BUEktVjEtMjAxOQ==',
    };
    if (!UserObj?.company_id) {
      logoutHandler();
    }
    this.props.LocationFilterAction(formData);
  };

  SeatTypemethod = seat => {
    this.setState({ type: seat.value });
  };

  SeatStatusMethod = status => {
    this.setState({ status: status.value });
  };

  render() {
    const seatType = [
      {
        value: 1,
        label: 'Fixed',
      },
      {
        value: 2,
        label: 'Flexi',
      },
    ];
    const seatStatus = [
      {
        value: 1,
        label: 'Booked',
      },
      {
        value: 2,
        label: 'Checked',
      },
      {
        value: 3,
        label: 'Ended',
      },
      {
        value: 4,
        label: 'Canceled',
      },
      {
        value: 5,
        label: 'Unused Booking',
      },
    ];
    const seatListData = this.props.seatBookingReducer;
    if (seatListData !== 0) {
      seatListData?.data &&
        seatListData?.data.list &&
        seatListData?.data.list.map((items, i) => {
          options.push({ value: items.title, label: items.title });
        });
    }

    if (seatListData !== 0) {
      seatListData?.data &&
        seatListData?.data.list &&
        seatListData?.data.list.map((items, i) => {
          options1.push({
            value: items.fname + ' ' + items.lname,
            label: items.fname + ' ' + items.lname,
          });
        });
    }

    if (seatListData !== 0) {
      seatListData?.data &&
        seatListData?.data.list &&
        seatListData?.data.list.map((items, i) => {
          options2.push({ value: items.phone, label: items.phone });
        });
    }

    const options3 = [];
    if (this.state.locationData !== 0) {
      this.state.locationData?.data &&
        this.state.locationData?.data.list &&
        this.state.locationData.map((items, i) =>
          options3.push({
            value: items.rec_id,
            label: items.location_name,
          }),
        );
    }
    const categoryOptions = [
      { value: '1', label: 'Private' },
      { value: '2', label: 'Shared' },
    ];
    const locationOptions = [
      { value: 'all', label: 'All' },
      ...(this.state.locationSpoc
        ? this.state.locationSpoc.map(item => ({
          value: item.rec_id,
          label: item.location_name,
        }))
        : []),
    ];

    return (
      <>
        <SwOffCanvas
          show={this.state.showFilterOffCanvas}
          onClose={this.handleCloseFilter}
          title="Seat Filters"
          footer={
            <div className="OffCanvasFooter_Btns">
              <SwButton
                variant="dark-outline"
                onClick={() => {
                  this.handleCloseFilter();
                  this.reload();
                }}
                className="ml10"
              >
                Reload
              </SwButton>
              <SwButton
                variant="primary"
                className="ml10"
                onClick={e => {
                  this.submitFilter(e);
                  this.handleCloseFilter();
                }}
              >
                Apply
              </SwButton>
            </div>
          }
        >
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Seat Type</label>
                <SwSelect
                  id="SBSeatType"
                  placeholder="Select Seat type"
                  name="type"
                  onChange={this.SeatTypemethod}
                  options={seatType}
                  isClearable={false}
                />
              </div>
            </div>
          </div>
          <div className="SwFormGroup">
            <label className="SwFormLabel">Seat Category</label>
            <SwSelect
              id="SBSeatCategory"
              name="category"
              options={categoryOptions}
              placeholder="Select Seat category"
              isClearable={false}
              value={categoryOptions.find(
                opt => opt.value === this.state.category,
              )}
              onChange={selectedOption => {
                this.changeSelect({
                  target: {
                    name: 'category',
                    value: selectedOption ? selectedOption.value : '',
                  },
                });
              }}
            />
          </div>
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Seat No.</label>
                <SwSelect
                  id="SBSeatNo"
                  placeholder="Select Seat No."
                  value={this.state.refreshSeat}
                  onChange={this.handleChange}
                  options={options}
                  isClearable={false}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">User Name </label>
                <SwSelect
                  id="SBUserName"
                  placeholder="Select User name"
                  value={this.state.refreshUser}
                  onChange={this.handleChange1}
                  options={options1}
                  isClearable={false}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Phone No. </label>
                <SwSelect
                  id="SBPhoneno"
                  placeholder="Select Phone No."
                  value={this.state.refreshphone}
                  onChange={this.handleChange2}
                  options={options2}
                  isClearable={false}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Location</label>
                <SwSelect
                  id="SBFLocation"
                  name="location"
                  options={locationOptions}
                  placeholder="Select Location"
                  isClearable={false}
                  value={locationOptions.find(
                    opt => opt.value === this.state.location,
                  )}
                  onChange={selectedOption => {
                    this.handelChangeValLang({
                      target: {
                        name: 'location',
                        value: selectedOption ? selectedOption.value : 'all',
                      },
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="SwFormGroup">
            <label className="SwFormLabel">Start Date</label>

            <AntDDatePicker
              value={
                this.state.startDate
                  ? dayjs(this.state.startDate, 'YYYY-MM-DD')
                  : null
              }
              format="YYYY-MM-DD"
              placeholder="Select Start Date"
              onChange={val =>
                this.setState({
                  startDate: val ? val.format('YYYY-MM-DD') : null,
                  endDate: null,
                })
              }
            />
          </div>
          <div className="SwFormGroup">
            <label className="SwFormLabel">End Date</label>
            <AntDDatePicker
              value={
                this.state.endDate
                  ? dayjs(this.state.endDate, 'YYYY-MM-DD')
                  : null
              }
              format="YYYY-MM-DD"
              placeholder="Select End Date"
              onChange={val =>
                this.setState({
                  endDate: val ? val.format('YYYY-MM-DD') : null,
                })
              }
              disabledDate={current =>
                this.state.startDate
                  ? current &&
                  current.isBefore(
                    dayjs(this.state.startDate, 'YYYY-MM-DD'),
                    'day',
                  )
                  : false
              }
            />
          </div>
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Status </label>
                <SwSelect
                  id="SBStatus"
                  placeholder="Select Status"
                  name="status"
                  onChange={this.SeatStatusMethod}
                  options={seatStatus}
                  isClearable={false}
                />
              </div>
            </div>
          </div>
        </SwOffCanvas>

        <SwIconButton size="sm" onClick={this.handleOpenFilter}>
          <i className="bi bi-funnel" />
        </SwIconButton>
      </>
    );
  }
}

const mapStateToProps = state => ({
  seatBookingReducer: state.seatBookingReducer.BookingList,
  LocationList: state.seatReducer.LocationFilterList,
});

const mapActionsToProps = {
  SeatBookingData,
  LocationFilterAction,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(SeatBookingFilter);
